export const SEARCH_TRACKING_EVENT_TYPE = {
  IL_GLOBAL_SEARCH: 'flGlobalSearch',
  IL_COMPANIES_QUICK_SEARCH: 'flCompaniesQuickSearch',
  IL_TERMS_QUICK_SEARCH: 'flTermsQuickSearch',
  IL_TAGS_QUICK_SEARCH: 'flTagsQuickSearch'
}
